import { Autocomplete, Grid, TextField, Typography, Button } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search'
import { Calendar } from "../../components/common/Calendar/Calendar"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { RoutesMap } from "../../types"
import { useCalendar } from "../../hooks/useCalendar"
import { useDepartmentStore } from "../../hooks/useDepartmentStore"
import { useOwnerStore } from "../../hooks/useOwnerStore"
import { ApiStatus } from "../../types/api/status"
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop"
import { Department } from "../../types/slices/departmentType"
import { useReservationStore } from "../../hooks/useReservationStore"
import { Owner } from "../../types/slices/ownerType"
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar"
  
export const ReservationBlockedView = () => {

    const navigate = useNavigate();
    
    const { addPeopleInvolved, resetCalendar, getCurrentRange, onChangeIsActionBlocked} = useCalendar();
    const { status: statusDepartment, departments, selectedDepartment, getDepartments, setSelectedDepartment } = useDepartmentStore()
    const { status: statusReservation, reservations, getReservations, getBlocked } = useReservationStore()

    const [showCalendar, setShowCalendar] = useState<boolean>(false);
    const [ownersByDepartament, setOwnersByDepartament] = useState<any>([]);

    useEffect(()=>{
        setSelectedDepartment({} as Department)
        getDepartments();
        onChangeIsActionBlocked(true)
        getBlocked();
    }, [])

    const onSearchAvailability = (e) => {
        e.preventDefault();
        resetCalendar(); 

        if (!selectedDepartment.id) return CustomSnackbar("warning",'Seleccione todos los campos')
        const params:any = {
            iddepartment: selectedDepartment.id,
            status: '1'
        }
        getReservations(params);
        setShowCalendar(true); 
    }

    const onSubmit = () => {
        if (!selectedDepartment.id ) return CustomSnackbar("warning","Seleccione todos los campos");

        const dates = getCurrentRange();
        if(!dates) return CustomSnackbar('warning', 'Aún no ha seleccionado su estadía.') 
            
        const data = {
            departament: selectedDepartment,
            owner: undefined,
        }

        addPeopleInvolved(data)
        navigate({ pathname: RoutesMap.RESERVATION_BLOCKED_CONFIRM}, { replace: true })
    }

    return (
      <>
        { statusDepartment === ApiStatus.FETCHING && <CustomBackdrop open={true} /> }
        { statusReservation === ApiStatus.FETCHING && <CustomBackdrop open={true} /> }
        <Grid container>
            <Grid item container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
                <Typography variant='h6' component='h1' gutterBottom color='#808080' className="tittle" sx={{ mt: 1, ml:1 , fontWeight:600 }}>
                    BLOQUEO MANUAL
                </Typography>
            </Grid>
            <Grid item container xs={12} direction="row" justifyContent="center" alignItems="center" sx={{border: 'solid 1px #e9e2e2', borderRadius:'10px'}}>
                    <Autocomplete
                        id="combo-box-department"
                        size="small"
                        options={departments || []}
                        getOptionLabel={(departament:any) => departament.name}
                        renderInput={(params) => <TextField {...params} label="Departamento" size="small"/>}
                        sx={{width:'300px', padding: '8px'}}
                        onChange={(e, newValue:any) => {
                            setShowCalendar(false);
                            setOwnersByDepartament(newValue ? newValue.owners : []);
                            setSelectedDepartment(newValue || {} as Department);
                        }}
                    />
                <Grid item display='flex'>
                    <Button 
                        startIcon={<SearchIcon/>} 
                        onClick={onSearchAvailability} 
                        size="small" 
                        variant="contained" 
                        sx={{ backgroundColor: '#212D39', color: '#fff', textTransform: 'none', padding: '8px', fontSize:"12px", "&:hover": {backgroundColor: "#212D39" } }}>
                            Buscar disponibilidad
                    </Button>
                </Grid>
            </Grid>
            {
                showCalendar && statusReservation === ApiStatus.FETCHED &&  (
                    <>
                    <Grid item container display='flex' justifyContent='center' sx={{padding:'15px 0px 3px 0px'}}>
                        <Calendar 
                            open={showCalendar}
                            datesRegister= {reservations}
                        />
                    </Grid>
                    <Grid item container display='flex' justifyContent='end'>
                        <Button 
                            onClick={onSubmit} 
                            size="small"
                            variant="contained" 
                            sx={{ background:'#73B2FF',color:'#fff', '&:hover':{bgcolor:'#007ea7'} }}>
                                Bloqueo
                        </Button>
                    </Grid>
                    </>
                )
            }
        </Grid>
        </>
    )
}